/** Legacy path. The primitive lives in `@/components/ui/input` (DESIGN.md §6). */
export { Input } from '@/components/ui/input';

export type { InputProps } from '@/components/ui/input';
